/**
 * src/components/shared/ComposeEmailButton.jsx — TICKET-206 top-bar "write email".
 *
 * Sits beside LeadSyncButton in the pipeline top bar. Opens ComposeEmailModal so
 * the CEO/admin can write a free-form email from anywhere in the pipeline,
 * through the same Gmail mailbox as the lead sync.
 */
import { useState } from 'react';
import { Pencil } from 'lucide-react';
import ComposeEmailModal from './ComposeEmailModal';
import { useT } from '../../lib/i18n/I18nContext';

export default function ComposeEmailButton() {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="nav-compose-email"
        onClick={() => setOpen(true)}
        aria-label={t('composeEmail.new')}
        title={t('composeEmail.new')}
        style={{
          width: 44, height: 44, minHeight: 44, borderRadius: 12,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'var(--accent-bg)', color: 'var(--accent)',
          border: 'none', boxShadow: 'inset 0 0 0 1px var(--bdr)',
          cursor: 'pointer', flexShrink: 0, transition: 'background 150ms var(--ease)',
        }}
      >
        <Pencil size={20} strokeWidth={1.75} />
      </button>
      <ComposeEmailModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
